import { render } from "./ReminderSingle.vue?vue&type=template&id=157b5500&scoped=true"
import script from "./ReminderSingle.vue?vue&type=script&lang=js"
export * from "./ReminderSingle.vue?vue&type=script&lang=js"

import "./ReminderSingle.vue?vue&type=style&index=0&id=157b5500&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157b5500"]])

export default __exports__